import { HIDE_MODAL, SHOW_MODAL, SPINNER_MODAL } from '../constants/show-modal'
import { ShowModalType } from '../../types/ShowModalType'
import ActionType from '../../types/ActionType'

const initialState: ShowModalType = {
  show: false,
  title: '',
  component: null,
  props: {},
  confirmLoading: false
}

export default (state = initialState, action: ActionType): ShowModalType => {
  switch (action.type) {
  case SHOW_MODAL:
    return {
      ...action.payload
    }
  case HIDE_MODAL:
    return {
      show: action.payload.show,
      component: null,
      title: '',
      props: {},
      confirmLoading: false
    }
  case SPINNER_MODAL:
    return {
      ...state,
      confirmLoading: action.payload.spinner
    }
  default:
    return state
  }
}
